export function startOauthFlow(provider = 'Google') {
  const redirectUri = process.env.GATSBY_COGNITO_REDIRECT_URI
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: process.env.GATSBY_COGNITO_APP_CLIENT_ID,
    redirect_uri: redirectUri,
    scope: 'openid email profile',       
    identity_provider: provider
  })
  window.location.href = `${process.env.GATSBY_COGNITO_DOMAIN}/oauth2/authorize?${params.toString()}`
}
